import { DatePipe as NgDatePipe } from '@angular/common';
import { Pipe } from '@angular/core';
import { dateTimeFormat } from '@core/config';

@Pipe({
    name: 'waiDateTime',
    standalone: false
})
export class DateTimePipe extends NgDatePipe {
  public override transform(value: Date | string | number, format?: string, timezone?: string, locale?: string): string | null;
  public override transform(value: null | undefined, format?: string, timezone?: string, locale?: string): null;
  public override transform(value: Date | string | number | null | undefined, format?: string, timezone?: string, locale?: string): string | null {
    if (value === null || value === undefined) {
      return null;
    }
    return super.transform(value, format || dateTimeFormat, timezone, locale);
  }
}
